<div class="row">
    <div *ngFor="let restaurant of restaurants" class="restaurant">
        <h1>{{restaurant}}</h1>
    </div>
</div>

<!-- If mobile view - make into carousel? -->